import { HasFactoryWaterMark } from '../../../classes/class-helpers/factory';
import { IsObject } from '../../../helpers';
import { NOTIFICATIONS_OBSERVABLE_PRIVATE } from './privates';
import { ConstructClassWithPrivateMembers } from '../../../misc/helpers/ClassWithPrivateMembers';
import { InitObservableHook } from '../../../core/observable/hook/init';
import { NewNotificationsObservableContext } from './context/implementation';
export function ConstructNotificationsObservable(instance, context, create) {
    ConstructClassWithPrivateMembers(instance, NOTIFICATIONS_OBSERVABLE_PRIVATE);
    const privates = instance[NOTIFICATIONS_OBSERVABLE_PRIVATE];
    privates.context = context;
    privates.observersMap = new Map();
    privates.othersObservers = [];
    InitObservableHook(instance, privates, NewNotificationsObservableContext, create);
}
export function IsNotificationsObservable(value) {
    return IsObject(value)
        && value.hasOwnProperty(NOTIFICATIONS_OBSERVABLE_PRIVATE);
}
export const IS_NOTIFICATIONS_OBSERVABLE_CONSTRUCTOR = Symbol('is-notifications-observable-constructor');
export function IsNotificationsObservableConstructor(value, direct) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_NOTIFICATIONS_OBSERVABLE_CONSTRUCTOR, direct);
}
//# sourceMappingURL=constructor.js.map